<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <b-tabs :value="activeTableIndex" lazy>
          <template #tabs-end>
            <div
              class="d-flex ml-auto align-items-center"
              v-can="{ slug: $route.meta.slug, action: 'C' }"
            >
              <b-button @click="regulationsModal = true" variant="success">
                <feather-icon icon="PlusIcon" class="mr-25" />
                إضافة
              </b-button>
            </div>
          </template>
          <b-tab
            @click="
              activeTableIndex = index;
              $router.push({
                name: 'settings-regulations',
                query: { model: tab.slug },
              });
            "
            :title="tab.title"
            v-for="(tab, index) in models"
            :key="tab.slug"
            :active="tab.slug === $route.query.model"
          >
            <data-table
              @row-clicked="
                $router.push({
                  name: 'settings-regulations-show',
                  params: { id: $event.id },
                  query: { model: tab.slug },
                })
              "
              
              ref="typesTable"
              hover
              :fields="fields"
              :ep="`v2/ministry/regulations?model=${$route.query.model}`"
            >
              <template #cell(actions)="{ item }">
                <div class="d-flex pr-2 w-100 justify-content-end">
                  <b-dropdown
                    variant="link"
                    no-caret
                    :right="$store.state.appConfig.isRTL"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>

                    <b-dropdown-item
                      v-can="{ slug: $route.meta.slug, action: 'U' }"
                      @click="
                        $refs.regulationsModal.init({
                          id: item.id,
                          name_ar: item.name_ar,
                        });
                        regulationsModal = true;
                      "
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">تعديل</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-can="{ slug: $route.meta.slug, action: 'D' }"
                      @click="onDeleteClicked(item.id)"
                    >
                      <feather-icon icon="Trash2Icon" />
                      <span class="align-middle ml-50">حذف</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </data-table>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
    <form-modal
      static
      ref="regulationsModal"
      title="أدخل معلومات النوع"
      :loading="working"
      :formSchema="regulationsFormSchema"
      v-model="regulationsModal"
      @confirm="onConfirm"
    >
    </form-modal>
  </div>
</template>

<script>
import {
  BRow,
  BTabs,
  BTab,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BCol,
  BCard,
  BButton,
  BFormRadioGroup,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import DataTable from "@/components/data-table";

export default {
  components: {
    BRow,
    BTabs,
    BTab,
    BDropdown,
    BDropdownItem,
    BFormFile,
    BCol,
    BCard,
    BButton,
    BFormRadioGroup,
    ToastificationContent,
    MinistryBreadcrumbs,

    FormModal,
    DataTable,
  },

  data() {
    return {
      regulationsModal: false,
      mainTitle: "المرجعيات القانونية",
      filter: "both",
      activeTableIndex: 0,
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "name_ar",
          label: "اسم نوع القرار",
        },

        {
          key: "actions",
          label: "",
        },
      ],

      models: [
        {
          title: "قانون الجمعيات و المؤسسات الخاصة و لائحته التنفيذية",
          slug: "law",
        },
        {
          title: "القوانين و المراسيم المرتبطة بعمل المنظمات غير الحكومية",
          slug: "decree",
        },
        {
          title: "التعاميم",
          slug: "circular",
        },
        {
          title: "القرارات",
          slug: "decision",
        },
        {
          title: "الأنظمة و الأدلة",
          slug: "system",
        },
      ],

      regulationsFormSchema: {
        name_ar: {
          component: "FormInput",
          key: "name_ar",
          attrs: {
            label: "اسم نوع التشريع",
            rules: "required",
          },
        },
        model: {
          key: "model",
        },
      },
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "المرجعيات القانونية",
          active: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters("Ministry/Settings/Regulations", ["working"]),
  },
  methods: {
    ...mapActions("Ministry/Settings/Regulations", [
      "editType",
      "addType",
      "deleteType",
    ]),
    setFilter(filter) {
      this.filter = filter;
    },
    async onConfirm(form) {
      if (form.id) {
        await this.editType(form);
      } else {
        await this.addType({ form, model: this.$route.query.model });
      }
      this.regulationsModal = false;
      this.$refs.typesTable[this.activeTableIndex].refreshTable();
    },
    // refreshTable() {
    //   this.$refs.dataTable.refresh();
    // },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف النوع ؟", {
          title: "تأكيد حذف النوع",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteType(id);
            this.$refs.typesTable[0].refreshTable();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
